import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TheoreticalForm from "../DialogForms/TheoreticalForm";
import PracticalInternalBuildingForm from "../DialogForms/PracticalInternalBuildingForm";
import PracticalExternalBuildingsForm from "../DialogForms/PracticalExternalBuildingsForm";
import ColloquiumForm from "../DialogForms/ColloquiumForm";
import { CurriculumItemTypes } from "utils/constants";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const MarkItemAsCompletedDialog = ({
  type,
  curriculumItemId,
  specialistId,
  isTrainingBuildingExternal,
  fetchModules,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const isColloquium = type === CurriculumItemTypes.Colloquium;
  const isTheoretical = type === CurriculumItemTypes.Theoretical;
  const isPracticalInternalBuilding = type === CurriculumItemTypes.Practical && isTrainingBuildingExternal === false;
  const isPracticalExternalBuildings = type === CurriculumItemTypes.Practical && isTrainingBuildingExternal === true;
  const isNullTrainingBuilding = type === CurriculumItemTypes.Practical && isTrainingBuildingExternal == null;

  const handleSubmit = async data => {
    if (isNullTrainingBuilding) {
      notify("Видът на базата за обучение не е зададен!", { type: "error" });
      return;
    }

    let payload = {};

    if (isTheoretical) {
      payload = {
        employees: data.employees,
      };
    } else if (isColloquium) {
      payload = {
        attendanceDate: data.attendanceDate,
        questions: data.questions,
        grade: data.grade,
        committeeMembers: data.committeeMembers,
      };
    } else if (isPracticalInternalBuilding) {
      payload = {
        certificateNumber: data.certificateNumber,
        employees: data.employees,
      };
    } else {
      payload = {
        dateFrom: data.dateFrom,
        dateTo: data.dateTo,
        certificateNumber: data.certificateNumber,
      };
    }

    await dataProvider.customRequest(
      specialistRequests.updateSpecialistCurriculumItemCompletions(specialistId, curriculumItemId),
      payload,
      "PUT",
    );
    notify("Успешно маркирахте темата за завършена!", { type: "success" });
    fetchModules();
    refresh();
  };

  if (isNullTrainingBuilding) return null;

  return (
    <FormModal
      titleContent={"Маркиране на темата за завършена"}
      onConfirm={handleSubmit}
      dialogSize="md"
      triggerButton={
        <Button
          label="Завършване"
          variant="contained"
          color="warning"
          startIcon={<TaskAltIcon />}
        />
      }
    >
      {isColloquium && <ColloquiumForm />}
      {isTheoretical && <TheoreticalForm />}
      {isPracticalInternalBuilding && <PracticalInternalBuildingForm />}
      {isPracticalExternalBuildings && <PracticalExternalBuildingsForm />}
    </FormModal>
  );
};

export default MarkItemAsCompletedDialog;
